import React from 'react'
import Landing from '../Component/Landing'

function MainLandingPage() {
  return (
    <div><Landing/></div>
  )
}

export default MainLandingPage